import { useMutation } from '@tanstack/react-query';

import useApi from '@/hooks/useApi/useApi';

type SignupParams = {
  email: string;
  name: string;
  title: string;
  company_name: string;
  password: string;
  newsletter_opted_in: boolean;
  terms_accepted: boolean;
  privacy_accepted: boolean;
  dpa_accepted: boolean;
  subscription_terms_accepted: boolean;
  registration_context?: string;
};

export const useSignup = () => {
  const { axiosInstance } = useApi();
  return useMutation({
    mutationFn: async (params: SignupParams) => {
      const { data } = await axiosInstance.post('/api/v1/signup', params);
      return data;
    },
  });
};
